import React from 'react';

import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';

const ItemSchema = {
  title: 'Value',
  properties: {
    text: {
      title: 'Text',
      widget: 'text',
    },
    link: {
      title: 'Internal Link',
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
    },
    color: {
      title: 'Color',
      widget: 'text',
    },
  },
  fieldsets: [
    {
      id: 'default',
      title: 'Value',
      fields: ['text', 'link', 'color'],
    },
  ],
  required: ['text', 'link', 'color'],
};

const TopLinksWidget = (props) => {
  return (
    <ObjectListWidget
      schema={ItemSchema}
      {...props}
      value={props.value?.items || props.default?.items || []}
      onChange={(id, value) => props.onChange(id, { items: value })}
    />
  );
};

export default TopLinksWidget;
